import gql from 'graphql-tag'

export const DemographicsEstimateQuery = gql`
  query getDemographicsEstimate($filters: AudienceFiltersInput!) {
    getDemographicsEstimate(filters: $filters) {
      totalCount
    }
  }
`
